import { DEBUGGER } from "@/helper/helper";
import { design } from "@/services/design";
import { useMutation, useQueryClient } from "react-query";
import { useCustomLogo, useUserDesign } from "@/states/design.state";
import useGenerateHomeQr from "@/components/page-modules/home-page/hooks/useGenerateHomeQr";
import { useConfig } from "@/states/common.state";
import { useRouter } from "next/router";
import useUpdateQrConfig from "@/components/page-modules/builder/__shared/hooks/request/useUpdateQrConfig";
import { QrTypeProps } from "@/components/page-modules/builder/__shared/data/builder-qr.type";

const useDeleteLogo = (selectedType: QrTypeProps) => {
  const queryClient = useQueryClient();
  const router = useRouter();

  const { customLogo } = useCustomLogo.getState();
  const { logo } = useUserDesign.getState();
  const { mutateHomeQr } = useGenerateHomeQr(false);
  const { payload, files } = useConfig.getState();
  const { updateQrConfig } = useUpdateQrConfig(selectedType);

  const { mutate: mutateDeleteLogo, isLoading: isDeleteLoading } = useMutation(
    (uuid: string) => design.deleteLogo(uuid),
    {
      onSuccess: () => {
        const isLogoMatch = logo.upload_logo === customLogo.logo?.uuid;

        if (isLogoMatch) {
          if (router.pathname.includes("/dashboard")) {
            updateQrConfig({
              optionlogo: "none",
              logo_size: 75,
            });
          } else {
            mutateHomeQr({
              params: { ...payload, files },
              configParams: { optionlogo: "none", logo_size: 75 },
            });
          }
        }

        queryClient.invalidateQueries("USER_LOGO");
      },
      onError: (error: unknown) => {
        DEBUGGER("Error while deleting logo => ", error);
      },
    },
  );

  return {
    mutateDeleteLogo,
    isDeleteLoading,
  };
};

export default useDeleteLogo;
